module.exports = __webpack_public_path__ + "img/title-feature.8af57201.png";